// Max slippage the user accepts between the price shown and the fill. It becomes the signed price limit
// of every order (OpenRequest.acceptablePx, CloseRequest.limitPx), so the relayer cannot fill past it.

const KEY = 'papurr:slippage-bps';
export const DEFAULT_SLIPPAGE_BPS = 50;
export const SLIPPAGE_CHOICES = [10, 50, 100] as const;
const MAX_BPS = 5_000;

export function getSlippageBps(): number {
  try {
    const v = Number(localStorage.getItem(KEY));
    return Number.isInteger(v) && v > 0 && v <= MAX_BPS ? v : DEFAULT_SLIPPAGE_BPS;
  } catch {
    return DEFAULT_SLIPPAGE_BPS;
  }
}

export function setSlippageBps(bps: number): number {
  const v = Math.min(MAX_BPS, Math.max(1, Math.round(bps)));
  try {
    localStorage.setItem(KEY, String(v));
  } catch {
    // storage blocked: the setting lasts for this visit
  }
  return v;
}

/**
 * Worst acceptable price for a trade at `mid`, in oracle units. Buying (opening a long, closing a short)
 * caps the price above the mid; selling (opening a short, closing a long) floors it below. Rounded in
 * the trader's favour (never looser than the setting).
 */
export function priceLimit(mid: bigint, buying: boolean, bps: number): bigint {
  const b = BigInt(bps);
  return buying ? (mid * (10_000n + b)) / 10_000n : (mid * (10_000n - b) + 9_999n) / 10_000n;
}
